import { useTranslation } from 'react-i18next'

import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { Text } from 'src/components/Text/Text'

import styles from './BrewGuide.module.scss'

import type { PostBrewGuide } from 'src/types/Post'

interface BrewGuideProps {
  brewguide: PostBrewGuide
}

export const BrewGuide = ({ brewguide }: BrewGuideProps) => {
  const { t } = useTranslation()
  const recipeAmounts = [
    {
      translation: t('cms.modules.brewGuide.weight'),
      value: brewguide.weight,
    },
    {
      translation: t('cms.modules.brewGuide.coarseness'),
      value: brewguide.coarseness,
    },
    {
      translation: t('cms.modules.brewGuide.waterAmount'),
      value: brewguide.waterAmount,
    },
    {
      translation: t('cms.modules.brewGuide.temperature'),
      value: brewguide.temperature,
    },
    {
      translation: t('cms.modules.brewGuide.duration'),
      value: brewguide.duration,
      info: brewguide.durationAmount,
    },
  ]

  return (
    <Container>
      <div className={styles.brewGuide}>
        <Headline variant="h2" className={styles.headline}>
          {t('cms.modules.brewGuide.headline')}
        </Headline>
        <ul className={styles.amountList}>
          {recipeAmounts.map((item) => (
            <li key={item.translation} className={styles.amountItem}>
              <Text small>
                {item.translation}
                <br />
                <strong>
                  {item.value}
                  {item.info && <span>{` ${item.info}`}</span>}
                </strong>
              </Text>
            </li>
          ))}
        </ul>

        <Text variant="intro" className={styles.itemsHeadline}>
          {t('cms.modules.brewGuide.itemsHeadline')}
        </Text>
        <ul className={`list ${styles.itemsList}`}>
          {brewguide.recipeItems.map((item) => (
            <li
              key={item['data-item']}
              className={styles.itemsItem}
              dangerouslySetInnerHTML={{ __html: item['data-item'] }}
              suppressHydrationWarning
            />
          ))}
        </ul>
      </div>
    </Container>
  )
}
